import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  TextField
} from '@mui/material'
import { useDispatch } from 'react-redux'
import {
  editOrganization,
  getTypesOrganizations
} from '../../../../redux/actions/Organizations'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar
} from '../../../../redux/actions/app'
import useStyleUpdateOrganization from './Styles/useStyleUpdateOrganization'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'

export default function StepperEditOrganization ({
  setLoading,
  setstateEditrganization,
  item
}) {
  const dispatch = useDispatch()
  const classes = useStyleUpdateOrganization()
  // all values  of organization for edit
  const [name, setname] = useState(item.organizationName)
  const [legalName, setlegalName] = useState(item.organizationLegalName)
  const [type, settype] = useState('')
  const [CUIT, setCUIT] = useState(item.organizationCuit)
  const [types, settypes] = useState([])
  const [maxAccount, setmaxAccount] = useState(item.organizationMaxAccessCount)
  // all errors  of organization for edit

  const [errorName, seterrorName] = useState(false)
  const [errorlegalName, seterrorlegalName] = useState(false)
  const [errorType, seterrorType] = useState(false)
  const [errorCUIT, seterrorCUIT] = useState(false)
  const [errorCUITText, seterrorCUITText] = useState('')
  const [errormaxAccount, seterrormaxAccount] = useState(false)

  const navigate = useNavigate()
  const refreshPage = () => {
    navigate(0)
  }

  useEffect(async () => {
    setLoading(true)
    settypes(await dispatch(getTypesOrganizations()))
    setLoading(false)
  }, [])

  useEffect(() => {
    if (types.length > 0) {
      getType()
    }
  }, [types])

  const handlenameChange = (event) => {
    setname(event.target.value)
  }
  const handlelegalNameChange = (event) => {
    setlegalName(event.target.value)
  }
  const handleTypeChange = (event) => {
    settype(event.target.value)
  }
  const handleCUITChange = (event) => {
    setCUIT(event.target.value)
  }
  const handleMaxAccountChange = (event) => {
    setmaxAccount(event.target.value)
    const number = parseInt(event.target.value)
    number > 0 ? clearErrors() : seterrormaxAccount(true)
  }

  const identicalCUIT = () => {
    if (CUIT === '' || (CUIT.length === 11 && !isNaN(parseInt(CUIT)))) {
      return true
    } else {
      seterrorCUITText('El CUIT debe contener 11 digitos')
      seterrorCUIT(true)
      return false
    }
  }

  const validateCUITNoEqual = () => {
    return CUIT !== item.organizationCuit
  }

  const isAttributesCompleted = () => {
    if (name === '') {
      seterrorName(true)
      seterrorlegalName(false)
      seterrorType(false)
      seterrorCUIT(false)
      return false
    }
    if (legalName === '') {
      seterrorlegalName(true)
      seterrorName(false)
      seterrorType(false)
      seterrorCUIT(false)

      return false
    }
    if (type === '') {
      seterrorType(true)
      seterrorName(false)
      seterrorlegalName(false)
      seterrorCUIT(false)
      return false
    }
    return identicalCUIT()
  }

  const clearErrors = () => {
    seterrorName(false)
    seterrorlegalName(false)
    seterrorType(false)
    seterrorCUIT(false)
    seterrormaxAccount(false)
  }
  const getTypeCode = () => {
    return types.find((element) => element.organizationTypeName === type)
      .organizationTypeId
  }
  const getType = () => {
    const type = types.find(
      (element) =>
        element.organizationTypeCode ===
        item.organizationType?.organizationTypeCode
    )
    settype(type.organizationTypeName)
  }

  const handlePrepareConditions = () => {
    clearErrors()
    const result = {}
    const typeCode = getTypeCode()
    result.organizationId = item.organizationId
    result.organizationName = name
    result.organizationTypeId = typeCode
    result.organizationlegalName = legalName
    result.organizationMaxAccessCount = maxAccount
    if (validateCUITNoEqual()) {
      result.organizationCuit = CUIT
    }
    return result
  }

  const handleEditFailure = (error) => {
    if (error.includes('CUIT')) {
      seterrorCUITText('Ya existe una organización con el CUIT ingresado')
      seterrorCUIT(true)
    } else {
      // error
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente.'))
    }
  }

  const handleEditOrganization = async () => {
    if (isAttributesCompleted()) {
      setLoading(true)
      const organization = handlePrepareConditions()
      const response = await dispatch(editOrganization(organization))
      if (response && response.response?.data?.status === 'Error') {
        handleEditFailure(response.response?.data?.error?.message)
      } else {
        setstateEditrganization(false)
        setTimeout(() => {
          refreshPage()
        }, 1000)
      }
      setLoading(false)
    }
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <Box className={classes.mainBox}>
          <Typography className={classes.editTypography}>
            Editar una organizaci&oacute;n
          </Typography>
          <Typography className={classes.instructionsTypography}>
            Para editar la organización modifique los campos que crea necesarios
          </Typography>

          <Typography className={classes.fieldsTypography}>
            Nombre de la organización
          </Typography>

          <TextField
            variant="outlined"
            required
            id="name"
            name="name"
            value={name}
            onChange={handlenameChange}
            size="small"
            className={classes.textFields}
            error={errorName}
            helperText={errorName ? 'Ingrese el nombre' : false}
          />
          <Typography className={classes.fieldsTypography}>
            Nombre legal
          </Typography>

          <TextField
            id="username"
            variant="outlined"
            size="small"
            name="legalName"
            value={legalName}
            onChange={handlelegalNameChange}
            className={classes.textFields}
            error={errorlegalName}
            helperText={errorlegalName ? 'Ingrese el nombre' : false}
          />
          <Typography className={classes.fieldsTypography}>CUIT</Typography>

          <TextField
            id="username"
            variant="outlined"
            size="small"
            name="legalName"
            value={CUIT}
            onChange={handleCUITChange}
            className={classes.textFields}
            error={errorCUIT}
            helperText={errorCUIT ? errorCUITText : false}
          />

          <Typography className={classes.fieldsTypography}>
            Tipo de organizaci&oacute;n
          </Typography>

          <FormControl
            variant="standard"
            className={classes.formControl}
            error={errorType}
            disabled
          >
            <Select
              labelId="demo-simple-select-filled-label"
              id="demo-simple-select-filled"
              value={type}
              onChange={handleTypeChange}
              size="small"
            >
              <MenuItem value="">
                <em></em>
              </MenuItem>
              {types
                ? (
                    types.map((type) => (
                  <MenuItem
                    key={type.organizationTypeName}
                    value={type.organizationTypeName}
                  >
                    {type.organizationTypeName}
                  </MenuItem>
                    ))
                  )
                : (
                <MenuItem value="">
                  No se encontraron tipos de usuarios
                </MenuItem>
                  )}
            </Select>
            {errorType
              ? (
              <FormHelperText>Seleccione un tipo</FormHelperText>
                )
              : null}
          </FormControl>
          <Typography className={classes.fieldsTypography}>
            M&aacute;ximo de usuarios
          </Typography>

          <TextField
            variant="outlined"
            required
            id="outlined-number"
            type="number"
            name="max"
            inputProps={{ inputMode: 'numeric', pattern: '[2]*' }}
            value={maxAccount}
            onChange={handleMaxAccountChange}
            size="small"
            className={classes.textFields}
            error={errormaxAccount}
            helperText={errormaxAccount ? 'Ingrese un numero' : null}
          />
        </Box>
        <Box className={classes.boxButton}>
          <Box
            className={classes.editButton}
            sx={{
              '&:hover': {
                bgcolor: '#1BF57F'
              }
            }}
          >
            <Typography
              onClick={() => {
                handleEditOrganization()
              }}
              className={classes.editButtonTypography}
            >
              Editar
            </Typography>
          </Box>
          <ButtonCancel setstateEditrganization={setstateEditrganization} />
        </Box>
      </Box>
    </>
  )
}

function ButtonCancel ({ setstateEditrganization }) {
  const classes = useStyleUpdateOrganization()
  return (
    <Box className={classes.cancelButton}>
      <Typography
        className={classes.cancelButtonTypography}
        onClick={() => {
          setstateEditrganization(false)
        }}
        sx={{
          '&:hover': {
            color: '#1BF57F'
          }
        }}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
